import { useRef } from "react"
import { useFrame, useThree } from "@react-three/fiber"
import * as THREE from 'three'

import { moveAxisRange, rotateAxisRange, moveAxis } from '../../../utils/moveObjects'
import { useActsStore } from "../../../store/useActsStore"

import Cockpit from "./Cockpit"
import Cylinder from "./Cylinder"
import Ovni from "./Ovni"

import { useSceneRef } from "../../../RefsProvider"
import { useIsMobile, useIsTouch } from "../../../utils/useIsMobile"
import { useDeviceTilt } from "../../../utils/useDeviceTilt"
import TextThree from "./TextThree"
import Train from "./Train"


export default function ActeThreeModels({ pointerRef }) {
    const isTouch = useIsTouch()
    const getAngles = useDeviceTilt()

    const ovniGroup = useRef()
    const initialPos = useRef(new THREE.Vector3(0, isTouch ? -3 : -2, 8))
    const target = new THREE.Vector3()
    const move = new THREE.Vector3()

    const targetEuler = new THREE.Euler()
    const targetQuat = new THREE.Quaternion()
    const smoothQuat = new THREE.Quaternion()

    const acteThreeModelRefBloom = useSceneRef("acteThreeModelRef")
    const FPS_REF = 60
    function alphaFromSpeed(speed, delta) {
        return 1 - Math.pow(1 - speed, delta * FPS_REF)
    }

    useFrame((state, delta) => {

        const stateActe = useActsStore.getState()
        const id = stateActe.getCurrentActId()
        const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0

        const maxPos = 2
        const maxRot = Math.PI * 0.35

        if (isTouch) {
            const a = getAngles()

            const pitch = THREE.MathUtils.clamp(a.pitch, -0.6, 0.6)
            const roll = THREE.MathUtils.clamp(a.roll, -0.6, 0.6)

            const x = initialPos.current.x + THREE.MathUtils.clamp(roll * state.viewport.width / 2, -maxPos, maxPos)

            const y = initialPos.current.y + THREE.MathUtils.clamp(pitch * state.viewport.height / 2, -maxPos, maxPos)

            target.set(x, y, initialPos.current.z)
            move.copy(ovniGroup.current.position).lerp(target, alphaFromSpeed(0.1, delta))
            ovniGroup.current.position.copy(move)

            const rotZ = THREE.MathUtils.clamp(-roll * state.viewport.width / 2, -maxRot, maxRot)

            targetEuler.set(0, 0, rotZ)
            targetQuat.setFromEuler(targetEuler)

            smoothQuat.copy(ovniGroup.current.quaternion).slerp(targetQuat, alphaFromSpeed(0.1, delta))

        } else {
            const x = initialPos.current.x + THREE.MathUtils.clamp(pointerRef.current.x * state.viewport.width / 2, -maxPos, maxPos)

            const y = initialPos.current.y + THREE.MathUtils.clamp(pointerRef.current.y * state.viewport.height / 2, -maxPos / 4, maxPos / 4)

            target.set(x, y, initialPos.current.z)
            move.copy(ovniGroup.current.position).lerp(target, alphaFromSpeed(0.1, delta))

            ovniGroup.current.position.copy(move)


            const rotZ = THREE.MathUtils.clamp(pointerRef.current.x * state.viewport.width / 2, -maxRot, maxRot)

            targetEuler.set(0, 0, rotZ)
            targetQuat.setFromEuler(targetEuler)

            smoothQuat.copy(ovniGroup.current.quaternion).slerp(targetQuat, alphaFromSpeed(0.1, delta))
        }

        ovniGroup.current.quaternion.copy(smoothQuat)

        moveAxisRange(ovniGroup, 'z', 8, 10, holdProgress, 0.5, 1.0, 0.05, delta)
    })



    return (
        <>
            <group ref={acteThreeModelRefBloom}>
                <Cylinder />
                <group ref={ovniGroup}>
                    <Cockpit scale={6} position={[0.022, 0, 0]} />
                    <Ovni scale={0.004} />
                </group>
                <Train targetRef={ovniGroup} position={[0,0.3,-1.35]}/>
                <TextThree />
            </group>

        </>
    )
}